<template>
  <div class="Page">
    <div class="title" v-if="$mq == 'desktop'">
      <div class="backButton">
            <img src="@/assets/next.svg" alt="" @click="$router.push({name: 'home'})">
      </div>
      <div>
        <div class="Wines">Les vins</div>
        <div class="nbrProduct"> {{`${bottleItems.length} produits`}} </div>
      </div>
      <div>
        <span  @click="display = !display, displayTrie = false" class="side">Filtres</span>
        <div v-if="display == true" class="backgroundPopup" id="filtre" @click.self="display = false">
          <div class="selectType">
            <span class="boxTitle">FILTRER PAR</span>
            <div class="box">
              <span>Type de vin</span>
              <div class="type">
                <div v-for="select in typeList" v-bind:key="select.type">
                  <div v-bind:class="chooseActive(select.isActive)" @click="selectType(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                </div>
              </div>
            </div>
            <div class="box">
              <span>Régions</span>
              <div class="type">
                <div v-for="select in regionList" v-bind:key="select.region">
                  <div v-bind:class="chooseActive(select.isActive)" @click="selectRegion(select.region), select.isActive = !select.isActive"> {{select.region}} </div>
                </div>
              </div>
            </div>
            <div class="box">
              <span>Millésime</span>
              <div class="type">
                <div v-for="select in millesimeList" v-bind:key="select.millesime">
                  <div v-bind:class="chooseActive(select.isActive)" @click="selectMillesime(select.millesime), select.isActive = !select.isActive"> {{select.millesime}} </div>
                </div>
              </div>
            </div>
          </div>
          <div class="valide" @click="display = false">Valider les filtres</div>
        </div>
      </div>
      <span class="side" @click="displayTrie = !displayTrie, display = false">Trier par</span>
      <div v-if="displayTrie == true" class="backgroundPopup" @click.self="displayTrie = false">
        <div class="selectType">
          <span class="boxTitle">TRIER PAR</span>
          <div class="box">
            <div class="typeTri">
              <div v-for="select in triList" v-bind:key="select.type">
                <div v-bind:class="chooseActive(select.isActive)" @click="selectTrie(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
              </div>
            </div>
          </div>
        </div>
        <div class="valideType" @click="displayTrie = false">Valider le tris</div>
      </div>
    </div>
    <div v-else :class="[`title-${$mq}`]">
      <div class="titleFirstBlock">
        <div class="backButton">
          <img src="@/assets/next.svg" alt="" @click="$router.push({name: 'home'})">
        </div>
        <div>
          <div class="Wines">Les vins</div>
          <div class="nbrProduct"> {{`${bottleItems.length} produits`}} </div>
        </div>
      </div>
      <div class="titleSegondBlock">
        <div>
        <span  @click="display = !display, displayTrie = false" class="side">Filtres</span>
        <div v-if="display == true" class="backgroundPopup" id="filtre" @click.self="display = false">
          <div class="selectType-mobile">
            <span class="boxTitle-mobile">FILTRER PAR</span>
            <div class="box-mobile">
              <span>Type de vin</span>
              <div class="type">
                <div v-for="select in typeList" v-bind:key="select.type">
                  <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectType(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                </div>
              </div>
            </div>
            <div class="box-mobile">
              <span>Régions</span>
              <div class="type">
                <div v-for="select in regionList" v-bind:key="select.region">
                  <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectRegion(select.region), select.isActive = !select.isActive"> {{select.region}} </div>
                </div>
              </div>
            </div>
            <div class="box-mobile">
              <span>Millésime</span>
              <div class="type">
                <div v-for="select in millesimeList" v-bind:key="select.millesime">
                  <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectMillesime(select.millesime), select.isActive = !select.isActive"> {{select.millesime}} </div>
                </div>
              </div>
            </div>
          </div>
          <div class="valide" @click="display = false">Valider les filtres</div>
        </div>
      </div>
      <span class="side" @click="displayTrie = !displayTrie, display = false">Trier par</span>
      </div>
      <div v-if="displayTrie == true" class="backgroundPopup" @click.self="displayTrie = false">
        <div class="selectType-mobile">
          <span class="boxTitle-mobile">TRIER PAR</span>
          <div class="box">
            <div class="typeTri">
              <div v-for="select in triList" v-bind:key="select.type">
                <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectTrie(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
              </div>
            </div>
          </div>
        </div>
        <div class="valideType" @click="displayTrie = false">Valider le tris</div>
      </div>
    </div>
    <div class="Items-Container" v-if="bottleItems.length > 0">
      <product-bottle
        v-for="bottle of bottleItems" :key="bottle.id"
        :title="bottle.title"
        :description="bottle.description"
        :price="bottle.price"
        :sold-out="bottle.soldOut"
        :image="bottle.image"
        :contentful-id="bottle.details"
        :isTasting="false"
        @click="openBottle(bottle.id)"
        class="bottleItems"
      />
    </div>

    <div v-else>
      {{ $t('global.loading') }}
    </div>
  </div>
</template>

<script>
import { VvHero } from '@/components/common'
import ProductBottle from '@/components/shop/ProductBottleResponcive'
import shopMixin from '@/mixins/shop'
import { mapGetters } from 'vuex'
import bottle from '@/store/modules/bottle'

export default {
  name: 'ShopListBottles',
  components: { VvHero, ProductBottle},
  mixins: [shopMixin],
  data() {
    return {
      display: false,
      displayTrie: false,
      typeItems: [],
      regionItem: [],
      millesimeItems: [],
      triList: [
        {type: 'Prix croissant', isActive: false},
        {type: 'Prix décroissant', isActive: false}
      ],
      typeList: [
        {type: 'Rosé', isActive : false},
        {type: 'Rouge', isActive : false},
        {type: 'Blanc', isActive : false},
        {type: 'Effervescent', isActive : false},
        {type: 'Effervescent rosé', isActive : false}
      ],
      regionList: [
        {region: 'Bourgogne', isActive : false},
        {region: 'Bordeaux', isActive : false},
        {region: 'Languedoc', isActive : false},
        {region: 'Sud-Ouest', isActive : false},
        {region: 'Beaujolais', isActive : false},
        {region: 'Roussillon', isActive : false},
        {region: 'Loire', isActive : false},
        {region: 'Savoie', isActive : false},
        {region: 'Champagne', isActive : false},
        {region: 'Provence', isActive : false},
        {region: 'Piémont', isActive : false},
        {region: 'Vallée du Rhône', isActive : false}
      ],
      millesimeList: [
        {millesime: '2020', isActive: false},
        {millesime: '2019', isActive: false},
        {millesime: '2018', isActive: false},
        {millesime: '2017', isActive: false},
        {millesime: '2016 et -', isActive: false},
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getBottleById'
    ]),
    bottleItems() {
      const bottles = []
      let alreadyPushed = []
      for (const bottle of this.bottles) {
        if (alreadyPushed.indexOf(bottle.id) == -1) {
          const splitTitle = bottle.title.split('||')
          const title = splitTitle[0]
          const description = splitTitle[1]

          const base = {
            title,
            id: bottle.id
          }
          
          bottles.push(
            Object.assign({}, base, {
              description,
              price: Number(bottle.variants[0].price),
              soldOut: !bottle.variants[0].available,
              contentfulId: bottle.variants[0].sku,
              image: bottle.images[0].src,
              details: this.getBottleById(bottle.variants[0].sku)
            })
          )
          alreadyPushed.push(bottle.id)
        }
      }
      if (this.typeItems.length != 0) {
        for (let i = 0; i < bottles.length; i++) {
          var select = 0
          for (let index = 0; index < this.typeItems.length; index++) {
            if (this.typeItems[index] == bottles[i].details.type) {
              select = 1
            }
          }
          if (select == 0) {
            bottles.splice(i, 1)
            i -= 1
          }
        }
      }
      if (this.regionItem.length != 0) {
        for (let i = 0; i < bottles.length; i++) {
          var select = 0
          for (let index = 0; index < this.regionItem.length; index++) {
            if (this.regionItem[index] == bottles[i].details.region) {
              select = 1
            }
          }
          if (select == 0) {
            bottles.splice(i, 1)
            i -= 1
          }
        }
      }
      if (this.millesimeItems.length != 0) {
        for (let i = 0; i < bottles.length; i++) {
          var select = 0
          for (let index = 0; index < this.millesimeItems.length; index++){
            if (this.millesimeItems[index] == bottles[i].details.millesime) {
              select = 1
            }
            if (this.millesimeItems[index] == "2016 et -") {
              let annee = bottles[i].details.millesime
              if (annee <= 2016) {
                select = 1
              }
            }
          }
          if (select == 0) {
            bottles.splice(i, 1)
            i -= 1
          }
        }
      }
      return bottles
    }
  },
  methods: {
    openBottle(bottleId) {
      this.$router.push({
        name: 'shop-full-bottle',
        params: {
          productId: bottleId
        }
      })
    },
    selectTrie(variable) {
      if (variable == 'Prix croissant') {
        this.triList[1].isActive = false
        this.bottleItems.sort(function(a, b) {
          return a.price - b.price
        })
      } else {
        this.triList[0].isActive = false
        this.bottleItems.sort(function(a, b) {
          return a.price - b.price
        })
        this.bottleItems.reverse()
      }
    },
    chooseActive(active) {
      return active == true ? "objet active" : "objet"
    },
    chooseActiveMobile(active) {
      return active == true ? "objet-mobile active" : "objet-mobile"
    },
    selectRegion(variable) {
      if (this.regionItem.indexOf(variable) !== -1) {
        for (let i = 0; i < this.regionItem.length; i++) {
          if (this.regionItem[i] == variable) {
            this.regionItem.splice(i, 1)
          }
        }
      } else {
        this.regionItem.push(variable)
      }
    },
    selectType(variable) {
      if (this.typeItems.indexOf(variable) !== -1) {
        for (let i = 0; i < this.typeItems.length; i++) {
          if (this.typeItems[i] == variable) {
            this.typeItems.splice(i, 1)
          }
        }
      } else {
        this.typeItems.push(variable)
      }
    },
    selectMillesime(variable) {
      if (this.millesimeItems.indexOf(variable) !== -1) {
        for (let i = 0; i < this.millesimeItems.length; i++) {
          if (this.millesimeItems[i] == variable) {
            this.millesimeItems.splice(i, 1)
          }
        }
      } else {
        this.millesimeItems.push(variable)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.bottleItems {
  margin: 0px 10px 45px 10px;

}
.Wines {
  font-size: 30px;
  font-weight: 700;
}
.backgroundPopup {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
  background-color: #e5e6f563;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex;
}
.valideType {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-size: 15px;
  height: auto;
  width: 90px;
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  color: white;
  background-color: rgba(209,10,74,255);
  cursor: pointer;
  margin: -20px 0px;
}
.valide {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-size: 15px;
  height: auto;
  width: 120px;
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  color: white;
  background-color: rgba(209,10,74,255);
  cursor: pointer;
  margin: -20px 0px;
}
.nbrProduct {
  margin-top: 2px;
  font-size: 13px;
}
.boxTitle {
  position: relative;
  left: 40%;
  margin-top: 15px;
  font-size: 130%;
  font-weight: 200;
}
.boxTitle-mobile {
  font-size: 100%;
  font-weight: 200;
}
.objet {
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  padding: 2px 15px;
  margin: 8px 10px;
  cursor: pointer;
}
.active {
  color: white;
  background-color: rgba(209,10,74,255);
}

.objet-mobile {
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  padding: 2px 15px;
  margin: 8px 10px;
  cursor: pointer;
  &:active {
    color: white;
    background-color: rgba(209,10,74,255);
  }
}
.typeTri {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.type {
  display: flex;
  flex-wrap: wrap;
}
.box {
  margin: 15px;
  font-size: 20px;
}
.box-mobile {
  margin: 5px;
  font-size: 15px;
}
.selectType {
  padding: 30px;
  z-index: -5;
  // top: 25%;
  // left: 37%;
  width: 35%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border: solid 2px $primary-alt;
  background-color: $primary-alt;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 5px #b3b2b2;
  -webkit-box-shadow: 0px 0px 10px 0px #b3b2b2;
  -moz-box-shadow: 0px 0px 10px 0px #b3b2b2;  
}
.selectType-mobile {
  overflow: auto;
  padding: 20px;
  z-index: -5;
  // top: 25%;
  // left: 37%;
  width: 85%;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: space-evenly;
  border: solid 2px $primary-alt;
  background-color: $primary-alt;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 5px #b3b2b2;
  -webkit-box-shadow: 0px 0px 10px 0px #b3b2b2;
  -moz-box-shadow: 0px 0px 10px 0px #b3b2b2;  
}
.side {
  display: flex;
  justify-content: center;
  width: 80px;
  height: auto;
  cursor: pointer;
  font-size: 17px;
  background-color: #F9FAFF;
  box-shadow:  3px 3px 3px #bebebe,
              -3px -3px 1px #ffffff;
  opacity: 1;
  padding: 3px 3px;
  border-radius: 20px;
}

.side:hover {
  box-shadow:  -3px -3px 3px #bebebe,
              3px 3px 1px #ffffff;
}

.title {
  align-items: center;
  font-size: auto;
  font-weight: 150;
  display: flex;
  width: 400px;
  margin-left: 20px;
  margin-bottom: 20px;
  // margin-right: 33%;
  margin-top: 10px;
  flex-direction: row;
  justify-content: space-between;
}
.title-mobile, .title-tablet {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.title-tablet {
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.title-mobile {
  flex-direction: column;
}

.titleSegondBlock {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title-mobile > .titleSegondBlock {
  margin-top: 20px;
}

.titleSegondBlock > div {
  margin: 0px 10px;
}

.titleFirstBlock {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.titleFirstBlock > .backButton{
  margin: 0px 50px 0px 20px ;
}

.Items-Container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 0 8px 60px;
  box-sizing: border-box;

  @media (max-width: 450px) {
    margin-top: 45px;
  }
}

.Page {
  padding: 15px 10px 10px 30px;
  @media (max-width: 450px) {
    margin-top: 0;
    padding: 15px 10px 10px 10px;
  }
}

.backButton {
  cursor: pointer;
  background-color: #F5F6FF;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow:  3px 3px 3px #bebebe,
             -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
  box-shadow:  -3px -3px 4px #bebebe,
             3px 3px 2px #ffffff;
  }
}

.listBottel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
</style>